<!-- <div class="row" *ngIf="!portfolioModel?.profileData?.is529"> -->
    <div class="row">
    <div class="header">Balanced Risk Strategies</div>
        <p class="mt-1 rps-paragraph-two" [innerHTML]="balancedRiskStrategies?.contentValue"></p>
    <div class="row">
        <div class="col-md-8 col-sm-12 col-lg-6">
            <div class="balance-risk-donut-chart">
                <exemplar-donut-chart [chartId]="chartId" [tableId]="tableId" [chartData]="chartAndTable"
                [decimals]="2" [selectPathData]="selectPathData">
                </exemplar-donut-chart>
            </div>
        </div>
        <div class="col-md-4 col-sm-12 col-lg-6 strategies-data">
            <cdk-accordion class="example-accordion">
                <cdk-accordion-item *ngFor="let item of chartAndTable; let index = index;"
                    #accordionItem="cdkAccordionItem" class="example-accordion-item" role="button" tabindex="0"
                    [attr.id]="'accordion-header-' + index" [attr.aria-expanded]="accordionItem.expanded"
                    [attr.aria-controls]="'accordion-body-' + index">
                    <div class="example-accordion-item-header"
                        (click)="accordionItem.toggle();selectPath(item.id, $event)"
                        [attr.id]="'accordion-item-'+index">
                        {{ item.name }}
                    </div>
                    <div class="example-accordion-item-body" role="region"
                        [style.display]="accordionItem.expanded ? '' : 'none'" [attr.id]="'accordion-body-' + index"
                        [attr.aria-labelledby]="'accordion-header-' + index" [innerHTML]="item.description">
                    </div>
                </cdk-accordion-item>
            </cdk-accordion>
        </div>
    </div>
</div>